export const featureFlags = {
  isFollowUpQuestionnaire: false,
  isInviteSubscriber: false,
  isSelectTestProfile: false,
  isManageTestProfile: false,
  isRegisterKit: false,
  isOrderKit: false
};